import {mergeRight, map} from 'ramda'
import { ConversationAPI, CustomerAPI } from 'api'

export const createFastlanePlaybook = ({ segmentId, name }) => (
  ConversationAPI.post('/playbooks/templated_playbooks/marketo_fast_lane', {
    playbookName: name,
    marketoSegmentId: segmentId
  })
)

export const getPlaybookInformation = (id) => (
  ConversationAPI.get(`/playbooks/${id}`)
)

export const getAllPlaybooks = async (orgId) => (
  ConversationAPI.get(`/playbooks/`, {params: {status: ['ENABLED', 'DISABLED', 'SENT', 'SCHEDULED', 'ARCHIVED']}})
)

export const unenrollFromSequence = async (endUserId) => (
  ConversationAPI.post(`/playbooks/unenroll`, { endUserId, unenrollmentReason: 'MANUAL' })
)

export const fetchEnrolledPlaybookId = async (email) => (
  ConversationAPI.post(`/sequences/for/v2`, { email })
)

export const getBotPlaybooks = async () => {
  const playbookTypes = ['BOOK_MORE_MEETINGS', 'EMPTY_LEADBOT', 'MORE_QUALIFIED_CONVERSATIONS', 'NPS_BOT', 'LANDING_PAGE_LEADBOT', 'VSB_DEFAULT_PLAYBOOK', 'CONVERSATION_STARTER_BOT',
    'RETARGETING_BOT', 'PRICING_PAGE_BOT', 'SECOND_NET_BOT', 'ABM_HOMEPAGE_BOT', 'PAID_TRAFFIC_BOT', 'ENGAGE_ALL_BOT', 'SKIP_THE_FORM_BOT', 'VISITOR_RETARGETING_BOT', 'BLOG_BOT',
    'PAID_AD_CONVERTER_BOT', 'TARGET_ACCOUNTS_BOT']

  return ConversationAPI.get(`/playbooks`, {params: {status: ['ENABLED', 'DISABLED'], reportType: playbookTypes}})
}

export const getSingleFullPB = async (id) => (
  ConversationAPI.get(`/playbooks/${id}`)
)

export const savePlaybook = async (pb) => (
  ConversationAPI.patch(`/playbooks`, pb)
)

export const savePlaybookDraft = async (id, pb) => (
  ConversationAPI.patch(`/playbooks/${id}/draft`, pb)
)

export const getPlaybookEvents = async (id) => {
  const { data } = await CustomerAPI.get(`/segment/events/playbook/${id}`)

  const moveEvent = event => {
    const { eventDefinition } = event

    delete event.eventDefinition

    event.type = 'PLAYBOOK'

    return mergeRight(event, eventDefinition)
  }

  return map(moveEvent, data)
}
